import React from "react";
import { LOGO_URL } from "../constants/site";

// Decorative AW monogram watermark used as background element
export const AWWatermark = ({ className = "", opacity = 0.04, size = 600, position = "right" }) => {
  const posStyle =
    position === "right"
      ? { right: "-120px", top: "50%", transform: "translateY(-50%)" }
      : { left: "-120px", top: "50%", transform: "translateY(-50%)" };
  return (
    <div
      aria-hidden
      className={`absolute pointer-events-none select-none ${className}`}
      style={{
        ...posStyle,
        width: size,
        height: size,
        backgroundImage: `url(${LOGO_URL})`,
        backgroundSize: "contain",
        backgroundRepeat: "no-repeat",
        opacity,
      }}
    />
  );
};
